import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { cloneDeep } from 'lodash';
import { GET_NAVBAR_MENUS } from 'mocks/queries';
import LoginSidebar from 'components/consumer/LoginSidebar/LoginSidebar';
import scrollToTop from 'commons/scrollToTop';
import normalizeInternalLink from 'commons/normalizeInternalLink';
import CtaButton from 'components/essentials/Cta/CtaButton';
import IconArrowRightSimple from 'components/icons/iconArrowRightSimple';
import ArrowDownSimples from 'components/icons/iconArrowDownSimple';
import CtaLink from 'components/essentials/Cta/CtaLink';
import useUserData from 'data-hooks/useUserData';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import useIsBrowser from 'hooks/useIsBrowser';
import IconUserAccount from '../../icons/iconUserAccount';
import ProgressLoader from '../../essentials/ProgressLoader/ProgressLoader';
import MobileShowroomLocator from './components/MobileShowroomLocator';
const ConsumerMobileFooterMenu = () => {
  const $ = _c(23);
  const isBrowser = useIsBrowser();
  const {
    data
  } = useSuspenseQuery(GET_NAVBAR_MENUS);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [menuVisible, setMenuVisible] = useState(t0);
  const [signInModalVisible, setSignInModalVisible] = useState(false);
  const {
    isLoggedIn,
    firstName
  } = useUserData();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = menuType => {
      setMenuVisible(prevState => {
        const updatedMenu = cloneDeep(prevState);
        updatedMenu[menuType] = !updatedMenu[menuType];
        return updatedMenu;
      });
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const toggleMenu = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setSignInModalVisible(true);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const showSignInModal = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setSignInModalVisible(false);
      scrollToTop();
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const hideSignInModal = t3;
  if (!data || data.loading) {
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="hidden max-[767px]:w-full max-[767px]:flex-col max-[767px]:justify-center max-[767px]:items-center max-[767px]:bg-white max-[767px]:flex max-[767px]:px-0 max-[767px]:py-4"><ProgressLoader color="dark-light" /></div>;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MobileShowroomLocator />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== data.getNavigationMenus || $[7] !== menuVisible) {
    t5 = data.getNavigationMenus && data.getNavigationMenus.learn?.map((t6, i) => {
      const {
        category
      } = t6;
      return category.map(t7 => {
        const {
          categoryTitle,
          subcategory
        } = t7;
        let categoryTitleLower = categoryTitle.toLowerCase();
        categoryTitleLower = categoryTitleLower.replace(" ", "");
        return <div className="w-full cursor-pointer border-b border-solid border-gray-light5" key={`${categoryTitleLower}_${i + 4}`}><button type="button" className="[background:none] border-0 flex w-full flex-row justify-between px-[3.333vw] py-4" onClick={() => toggleMenu(`${categoryTitleLower}`)}><div className="text-[.78rem] leading-[.9rem] text-gray-light1 font-bold">{categoryTitle}</div><div className="w-[.9rem] h-[.9rem] leading-[.9rem] -mt-0.5 flex justify-center items-center [&_img]:h-full">{!menuVisible[`${categoryTitleLower}`] ? <IconArrowRightSimple /> : <ArrowDownSimples width={16} height={9} />}</div></button><div className={classNames("menu-list transition-all duration-700 w-full", {
            "flex flex-col opacity-100": menuVisible[categoryTitleLower],
            "hidden flex-col opacity-0": !menuVisible[categoryTitleLower]
          })}><ul>{subcategory && subcategory.map(_temp)}</ul></div></div>;
      });
    });
    $[6] = data.getNavigationMenus;
    $[7] = menuVisible;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== data.getNavigationMenus || $[10] !== menuVisible) {
    t6 = data.getNavigationMenus && data.getNavigationMenus.shop?.map((t7, i_0) => {
      const {
        category: category_0
      } = t7;
      return category_0.map(t8 => {
        const {
          categoryTitle: categoryTitle_0,
          subcategory: subcategory_0
        } = t8;
        let categoryTitleLower_0 = categoryTitle_0.toLowerCase();
        categoryTitleLower_0 = categoryTitleLower_0.replace(" & ", "");
        return <div className="w-full cursor-pointer border-b border-solid border-gray-light5" key={`${categoryTitleLower_0}_${i_0 + 4}`}><button type="button" className="[background:none] border-0 flex w-full flex-row justify-between px-[3.333vw] py-4" onClick={() => toggleMenu(`${categoryTitleLower_0}`)}><div className="text-[.78rem] leading-[.9rem] text-gray-light1 font-normal">{categoryTitle_0}</div><div className="w-[.9rem] h-[.9rem] leading-[.9rem] -mt-0.5 flex justify-center items-center [&_img]:h-full">{!menuVisible[`${categoryTitleLower_0}`] ? <IconArrowRightSimple /> : <ArrowDownSimples width={16} height={9} />}</div></button><div className={classNames("menu-list transition-all duration-700 w-full", {
            "flex flex-col opacity-100": menuVisible[categoryTitleLower_0],
            "hidden flex-col opacity-0": !menuVisible[categoryTitleLower_0]
          })}><ul>{subcategory_0 && subcategory_0.map(_temp2)}</ul></div></div>;
      });
    });
    $[9] = data.getNavigationMenus;
    $[10] = menuVisible;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== firstName || $[13] !== isBrowser || $[14] !== isLoggedIn) {
    t7 = <div className="w-full cursor-pointer border-b border-solid border-gray-light5"><div className="opacity-100 transition-all duration-700"><div className="[background:none] border-0 w-full flex flex-row justify-around">{!isLoggedIn || !isBrowser ? <><button type="button" onClick={evt => {
              evt.preventDefault();
              showSignInModal();
            }}>Login</button><Link className="border-l-[1px] border-solid border-l-gray-light5 w-1/2 text-center px-0 py-4 text-[.78rem] font-normal leading-[.9rem] text-gray-light1 cursor-pointer" to="/contact-us/">Contact Us</Link></> : <><div className="flex flex-col items-center border-l-0 w-full"><div className="pt-4 pb-2 text-[.78rem] font-normal leading-[.9rem]"><span className="break-words">Hi, {firstName}</span></div><div className="pt-0 px-6 pb-4 border-l-0 w-full"><CtaLink to="/customer/dashboard/" hasArrow={false}><IconUserAccount className="w-4" /><div className="no"><span className="[&_button]:p-0 [&_button]:ml-[5px]"><CtaButton style={{
                        background: {
                          padding: 0
                        }
                      }} styling="link" color="brand" size="sm" hasArrow={false} block={true}>Go to Account</CtaButton></span></div></CtaLink></div></div><div className="border-l-[1px] border-solid border-l-gray-light5 w-1/2 text-center px-0 py-4 text-[.78rem] font-normal leading-[.9rem] text-gray-light1 cursor-pointer"><a href="/contact-us/">Contact Us</a><div /></div></>}</div></div></div>;
    $[12] = firstName;
    $[13] = isBrowser;
    $[14] = isLoggedIn;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== signInModalVisible) {
    t8 = <LoginSidebar show={signInModalVisible} onClose={hideSignInModal} />;
    $[16] = signInModalVisible;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t9 = <div className="hidden max-[767px]:flex max-[767px]:flex-col max-[767px]:w-full max-[767px]:m-0">{t4}{t5}{t6}{t7}{t8}</div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
export default ConsumerMobileFooterMenu;
function _temp(t0) {
  const {
    subcategoryTitle,
    link
  } = t0;
  if (subcategoryTitle === "Reviews") {
    return null;
  }
  if (subcategoryTitle === "Blog") {
    return <li key={`${subcategoryTitle}-link1`}><a key={`${subcategoryTitle}`} href="https://joybird.com/blog/">{subcategoryTitle}</a></li>;
  }
  if (subcategoryTitle === "FAQ") {
    return <li key={`${subcategoryTitle}-link2`}><a key={`${subcategoryTitle}`} href={link}>{subcategoryTitle}</a></li>;
  }
  return <li key={`${subcategoryTitle}-link3`}><Link to={normalizeInternalLink(link)} key={`${subcategoryTitle}`}>{subcategoryTitle}</Link></li>;
}
function _temp2(t0) {
  const {
    subcategoryTitle: subcategoryTitle_0,
    link: link_0
  } = t0;
  return <li key={`${subcategoryTitle_0}-li4`}><Link to={normalizeInternalLink(link_0)} key={`${subcategoryTitle_0}`}>{subcategoryTitle_0}</Link></li>;
}